// extracted by mini-css-extract-plugin
export default {"list":"AddContributorModal_list__K-rOv","text":"AddContributorModal_text__GGXVS","role":"AddContributorModal_role__Nr4fD"};